export default "__VITE_ASSET__DVU7guom__"